import { SPINNING_WHEEL_TYPE } from "@cede/types";
import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useTelegramContext } from "@/contexts/TelegramContext";
import { useApi } from "@/hooks/core/useApi";
import { useHubUser } from "@/hooks/user/useHubUser";
import { useQuery } from "@tanstack/react-query";

interface UseSpinningWheelEligibilityOptions {
  spinningWheelType: SPINNING_WHEEL_TYPE;
  enabled?: boolean;
}

/**
 * Hook to check spinning wheel eligibility using the dedicated endpoint
 * This checks both quest completion status and underlying requirements (TON user, etc.)
 */
export const useSpinningWheelEligibility = ({
  spinningWheelType,
  enabled = true,
}: UseSpinningWheelEligibilityOptions) => {
  const { hubUser, auth } = useHubUser();
  const apiHelper = useApi();
  const { isTMA } = useTelegramContext();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [QueryKeys.SPINNING_WHEEL_ELIGIBILITY, spinningWheelType, hubUser?.id],
    queryFn: () =>
      apiHelper.getWithAuth(auth, API_ENDPOINT.SPINNING_WHEEL_TMA_ELIGIBILITY, {
        queryParams: { spinningWheelType },
      }),
    enabled: enabled && !!hubUser?.id && isTMA,
    staleTime: 30 * 1000,
    retry: 2,
  });

  return {
    isEligible: data?.isEligible ?? false,
    questId: data?.questId,
    reason: data?.reason,
    isLoading,
    error: error?.message ?? null,
    refetch,
  };
};
